'use strict';
const _ = require('lodash');
const get = (ctx, prefix, attribute) => {
  const path = _.isNil(prefix) ? [attribute] : [`${prefix}${_.upperFirst(attribute)}`];
  return _.get(ctx, path);
};

const formatStreet = (ctx, prefix) => {
  const street = get(ctx, prefix, 'street') || '';
  const houseNumber = get(ctx, prefix, 'houseNumber_i') || '';
  const houseNumberAddition = get(ctx, prefix, 'houseNumberAddition') || '';

  // check if houseNumberAddition starts with a number, if so combine it with houseNumber to properly format it.
  if (/^[0-9]/.test(houseNumberAddition) && !_.isNil(houseNumber)) {
    return `${street} ${houseNumber}-${houseNumberAddition}`;
  }

  return [street, houseNumber, houseNumberAddition]
    .filter(line => !_.isNil(line) && !_.isEmpty(_.trim(line)))
    .join(' ').trim();
};

const formatAddress = (ctx, prefix) => {
  const countryCodePath = _.isNil(prefix) ? ['country', 'countryCodeAlpha3'] : [`${prefix}Country`, 'countryCodeAlpha3'];
  const countryCode = _.get(ctx, countryCodePath);

  if (countryCode === 'NLD') {
    const street = formatStreet(ctx, prefix);
    const indication = get(ctx, prefix, 'indication') || '';
    const postalCode = get(ctx, prefix, 'postalCode') || '';
    const city = get(ctx, prefix, 'city');

    return [
      street,
      indication,
      `${postalCode} ${city}`
    ].filter(line => !_.isNil(line) && !_.isEmpty(_.trim(line))).map(_.trim);
  }

  const countryNamePath = _.isNil(prefix) ? ['country', 'display'] : [`${prefix}Country`, 'display'];
  const countryName = _.get(ctx, countryNamePath);

  return [
    `${get(ctx, prefix, 'addressLine1') || ''}`,
    `${get(ctx, prefix, 'addressLine2') || ''}`,
    `${get(ctx, prefix, 'addressLine3') || ''}`,
    `${get(ctx, prefix, 'addressLine4') || ''}`,
    countryName
  ].filter(line => !_.isNil(line) && !_.isEmpty(_.trim(line)));
};

module.exports = formatAddress;
